module.exports = __webpack_public_path__ + "img/zhongxinGH4.e262c3fa.png";